document.addEventListener("DOMContentLoaded", function () {
  const modal = document.querySelector("#AuraQuickView");
  const overlay = document.querySelector(".aura-qv-overlay");

  const mediaEl = document.querySelector("[data-aura-qv-media]");
  const titleEl = document.querySelector("[data-aura-qv-title]");
  const priceEl = document.querySelector("[data-aura-qv-price]");
  const descEl = document.querySelector("[data-aura-qv-description]");
  const detailsEl = document.querySelector("[data-aura-qv-details]");
  const optionsEl = document.querySelector("[data-aura-qv-options]");
  const variantInput = document.querySelector("[data-aura-qv-variant-id]");
  const form = document.querySelector("[data-aura-qv-form]");

  let currentProduct = null;

  function money(cents) {
    return "$" + (cents / 100).toFixed(2);
  }

  function openModal() {
    modal.classList.add("is-open");
    overlay.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeModal() {
    modal.classList.remove("is-open");
    overlay.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function selectedOptions() {
    return Array.from(optionsEl.querySelectorAll("select")).map((select) => select.value);
  }

  function findVariant() {
    const selected = selectedOptions();
    return currentProduct.variants.find((variant) => {
      return variant.options.every((option, index) => option === selected[index]);
    });
  }

  function updateVariant() {
    const variant = findVariant();
    if (!variant) return;

    variantInput.value = variant.id;
    priceEl.textContent = money(variant.price);
  }

  async function loadProduct(url) {
    const cleanUrl = url.split("?")[0].replace(window.location.origin, "");
    const res = await fetch(cleanUrl + ".js");
    const product = await res.json();

    currentProduct = product;

    mediaEl.innerHTML = "";
    product.images.slice(0, 4).forEach((img) => {
      const image = document.createElement("img");
      image.src = img;
      image.alt = product.title;
      mediaEl.appendChild(image);
    });

    titleEl.textContent = product.title;
    priceEl.textContent = money(product.price);
    descEl.innerHTML = product.description || "";
    detailsEl.href = product.url;

    optionsEl.innerHTML = "";

    product.options.forEach((option, index) => {
      const wrapper = document.createElement("div");
      wrapper.className = "aura-qv__option";

      const label = document.createElement("label");
      label.textContent = option.name;

      const select = document.createElement("select");
      select.className = "aura-qv__select";

      option.values.forEach((value) => {
        const opt = document.createElement("option");
        opt.value = value;
        opt.textContent = value;
        select.appendChild(opt);
      });

      select.addEventListener("change", updateVariant);

      wrapper.appendChild(label);
      wrapper.appendChild(select);
      optionsEl.appendChild(wrapper);
    });

    if (product.variants.length) {
      variantInput.value = product.variants[0].id;
    }

    openModal();
  }

  document.addEventListener("click", function (event) {
    const btn = event.target.closest(".aura-open-qv");
    if (!btn) return;

    event.preventDefault();
    event.stopPropagation();

    const productUrl = btn.dataset.productUrl;
    if (!productUrl) return;

    loadProduct(productUrl);
  });

  document.querySelectorAll("[data-aura-qv-close]").forEach((el) => {
    el.addEventListener("click", closeModal);
  });

  form.addEventListener("submit", async function (event) {
    event.preventDefault();

    const formData = new FormData(form);

    await fetch("/cart/add.js", {
      method: "POST",
      body: formData,
      headers: { Accept: "application/json" }
    });

    window.location.reload();
  });
});